exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::v-deep .el-dialog__body{\n  padding:15px 20px\n}", ""]);

// exports
